import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

/**
 * Shared by the section and its loading skeleton — the see-all button renders
 * in both, so a click during the loading window tracks identically.
 */
export function useTrackAllTopicsClick(): () => void {
	const track = useTracking();

	return useCallback(() => {
		void track('homepage_all_topics_click');
	}, [track]);
}
